import { fetchJson } from "src/utils/apiUtils";
import {
  IRemyndProduct,
  IRemyndProductPaginateReq,
  IRemyndProductSaveReq
} from "./types";

const endpoint = `master/remyndProduct`;

export const list = async (search: IRemyndProductPaginateReq) => {
  return fetchJson<IResponse<IPaginateResponse<IRemyndProduct>>>(
    `${endpoint}/listPaginate`,
    {
      method: "POST",
      body: JSON.stringify({ ...search })
    }
  );
};

export const get = async (id: RemyndProductId) => {
  return fetchJson<IResponse<IRemyndProduct>>(`${endpoint}/${id}`, {
    method: "GET"
  });
};

export const save = async (req: IRemyndProductSaveReq) => {
  return fetchJson<IResponse<RemyndProductId>>(`${endpoint}/save`, {
    method: "POST",
    body: JSON.stringify({ ...req })
  });
};

export const update = async (
  id: RemyndProductId,
  req: IRemyndProductSaveReq
) => {
  return fetchJson<IResponse<RemyndProductId>>(`${endpoint}/update/${id}`, {
    method: "POST",
    body: JSON.stringify({ ...req })
  });
};

export const deleteMultiple = async (req: ICommonIdsReq) => {
  return fetchJson<IResponse<null>>(`${endpoint}/delete`, {
    method: "DELETE",
    body: JSON.stringify({ ...req })
  });
};
